import Hidden from '@material-ui/core/Hidden';
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import buttonBlue from "assets/EnergyCompany/jss/button-blue.jsx";
import centerStyle from "./center";
import logo from "assets/EnergyCompany/img/logo.svg";

const style = theme => ({
  button: { ...buttonBlue },
  centeredSection: {
    ...centerStyle(theme),
  },
  contato: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    "& span": {
      fontSize: "12px",
      marginTop: "10px",
    },
  },
  copyright: {
    color: "darkgrey",
    marginTop: "50px",
    [theme.breakpoints.down("sm")]: {
      margin: "20px",
    },
  },
  logo: {
    width: "200px",
  },
  li: {
    cursor: "pointer",
    display: "inline-block",
    listStyle: "none",
    marginLeft: theme.spacing.unit * 2,
    textTransform: "uppercase",
    "& a": {
      color: "black",
    },
  },
  links: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
  },
  main: {
    backgroundColor: "white",
    color: "black",
    padding: "50px",
    [theme.breakpoints.down("sm")]: {
      padding: "0",
    },
  },
  sectionWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  ul: {
    margin: 0,
    padding: 0,
  },
});

const Footer = ({ classes, history, user }) => (
  <main className={classes.main}>
    <section className={classes.centeredSection}>
      <div className={classes.sectionWrapper}>
        <img alt="Logo" className={classes.logo} src={logo} />
        <div className={classes.links}>
          <ul className={classes.ul}>
            <Hidden smDown>
              <li className={classes.li}>
                <a href="/planos">Planos</a>
              </li>
              <li className={classes.li}>
                <a href={"#sobre-nos"}>Sobre Nós</a>
              </li>
              <li className={classes.li}>
                <a href={"#contato"}>Contato</a>
              </li>
            </Hidden>
          </ul>
          <span className={classes.copyright}>
            {"©" +  (new Date()).getFullYear() + " Energy Company | Todos os direitos reservados"}
          </span>
        </div>
        <div className={classes.contato}>
          {user.access_token ? (
            <button className={classes.button} onClick={() => history.push("/dashboard")}>
              DASHBOARD
            </button>
          ) : (
            <button className={classes.button} onClick={() => history.push("/login")}>
              LOGIN
            </button>
          )}
          <span>(81) 99921-0131</span>
        </div>
      </div>
    </section>
  </main>
);

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.object.isRequired,
};

export default withStyles(style)(Footer);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/6-footer.js